export const BENEFICIARY_PROFILE_TABS = [
  { id: 'profil', label: 'Profil' },
  { id: 'prestations', label: 'Prestations' },
  { id: 'resultats-tests', label: 'Résultats aux tests' },
  { id: 'resultats-ressources', label: 'Résultats des ressources' },
] as const;

export type BeneficiaryProfileTabId = (typeof BENEFICIARY_PROFILE_TABS)[number]['id'];

export const MISSING_VALUE = 'Donnée manquante';

export const EMAIL_TAKEN_MESSAGE = 'Cette adresse email est déjà associée à un autre compte';

export const EMAIL_INVALID_MESSAGE = "Le format de l'adresse email est invalide";

export const EDIT_PROFILE_TITLE = 'Modifier le profil du bénéficiaire';

export const PROFILE_UPDATED_MESSAGE = 'Le profil a été mis à jour avec succès';

export const GENERATED_PASSWORD_TITLE = 'Générer un mot de passe aléatoirement';

export const GENERATED_PASSWORD_TEXT =
  "Transmettez ce mot de passe temporaire au bénéficiaire afin qu'il puisse définir un nouveau mot de passe.";

export const STATUS_ACTIVE = 'Actif';
export const STATUS_INACTIVE = 'Inactif';

export const DISABLE_USER_TITLE = "Êtes-vous sûr de vouloir désactiver l'utilisateur ?";
export const DISABLE_USER_TEXT =
  "Vous êtes sur le point de désactiver l'utilisateur. Le statut de l'utilisateur passera de “Actif” à “Inactif”.";
export const DISABLE_USER_CONFIRM = 'Désactiver';
export const DISABLE_USER_SUCCESS = "L'utilisateur a bien été désactivé.";

export const ENABLE_USER_TITLE = "Êtes-vous sûr de vouloir réactiver l'utilisateur ?";
export const ENABLE_USER_TEXT =
  "Vous êtes sur le point de réactiver l'utilisateur. Le statut de l'utilisateur passera de “Inactif” à “Actif”.";
export const ENABLE_USER_CONFIRM = 'Réactiver';
export const ENABLE_USER_SUCCESS = "L'utilisateur a bien été réactivé.";

export const DELETE_USER_TITLE = 'Suppression définitive';
export const DELETE_USER_TEXT =
  'Êtes-vous sûr de vouloir supprimer ce compte ? Cette action est définitive.';
export const DELETE_USER_CONFIRM = 'Confirmer';
export const DELETE_USER_SUCCESS = 'Le compte a bien été supprimé.';

export const DELETE_PRESTATION_TITLE = 'Supprimer la prestation';
export const DELETE_PRESTATION_CONFIRM = 'Supprimer';
export const DELETE_PRESTATION_SUCCESS = 'La prestation a été supprimée';
export const buildDeletePrestationText = (prestationName: string, consultantName?: string) => {
  const consultantPart = consultantName ? ` rattachée au consultant ${consultantName}` : '';
  return `Êtes-vous sûr de vouloir supprimer la prestation « ${prestationName} »${consultantPart} ? Cette action est irréversible. Les ressources attribuées dans le cadre de cette prestation seront également retirées.`;
};

export const MAJOR_TEST_CATALOG: Array<{
  id: number;
  name: string;
  resultKey: string;
  resultPath: (resultId: number | string) => string;
}> = [
  {
    id: 1,
    name: 'Sens® – test des 10 valeurs',
    resultKey: 'meaningTestLastResult',
    resultPath: resultId => `/resultat-meaning-value/${resultId}`,
  },
  {
    id: 2,
    name: 'Needs® – test des 7 besoins professionnels et personnels',
    resultKey: 'needsTestLastResult',
    resultPath: resultId => `/resultat-need/${resultId}`,
  },
  {
    id: 3,
    name: 'Needs® pro – test des 7 besoins professionnels',
    resultKey: 'needsProTestLastResult',
    resultPath: resultId => `/resultat-need-pro/${resultId}`,
  },
  {
    id: 4,
    name: 'Préférences® – test des 32 personnalités',
    resultKey: 'preferenceTestLastResult',
    resultPath: resultId => `/resultat-preference/${resultId}`,
  },
  {
    id: 5,
    name: 'Harmony® – test des 16 soft skills',
    resultKey: 'harmonyTestLastResult',
    resultPath: resultId => `/resultat-harmony/${resultId}`,
  },
  {
    id: 6,
    name: "Study® – test d'orientation",
    resultKey: 'studyTestLastResult',
    resultPath: resultId => `/resultat-study/${resultId}`,
  },
  {
    id: 7,
    name: 'Préférences® Jeunes',
    resultKey: 'preferenceJeuneLastResult',
    resultPath: resultId => `/res-pref-j/${resultId}`,
  },
];
